import React, { useMemo } from 'react';
import { Cell } from 'styled-css-grid';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

import Input from '@xcritical/input';
import { formSelector } from '@xcritical/forms';

import { createUrl } from '@crm-framework/url';
import { CopyIconButton } from '@crm-framework/copy-icon-button';

import {
  getDictionaryByNameSelector,
  IStoreWithDictionary,
} from '@crm-package/dictionaries';

import { PROMO_FORM_NAME } from '../consts';
import { getMyAccountUrlByEnvironmentId } from '../utils';
import { IPromoDictionaries } from '../types';

// TODO change interface to ILead
export const LeadPromoLinkComponent: React.FC<any> = ({
  lead: { environmentId },
}: any) => {
  const { myAccountUrls, guid } = useSelector(
    (state: IStoreWithDictionary<IPromoDictionaries>) => {
      const promoForm = formSelector(state, PROMO_FORM_NAME);
      const promoGuid = get(promoForm, ['model', 'guid'], '');
      const myAccountUrlsDictionary = getDictionaryByNameSelector(
        state,
        'myAccountUrls'
      );

      return {
        guid: promoGuid,
        myAccountUrls: myAccountUrlsDictionary,
      };
    }
  );

  const url = useMemo(
    () =>
      createUrl({
        href: getMyAccountUrlByEnvironmentId(myAccountUrls, environmentId),
        query: {
          Promo: guid,
        },
      }),
    [environmentId, myAccountUrls]
  );

  return (
    <>
      <Cell width={2}>
        <Input
          spellCheck={false}
          name="link"
          value={url || ''}
          placeholder="Link"
          shouldFitContainer
          prefix={<CopyIconButton text={url} />}
        />
      </Cell>
    </>
  );
};
